import mapboxgl from "mapbox-gl"
import 'mapbox-gl/dist/mapbox-gl.css';
class Map {
  static init() {
    if (document.getElementById('mapbox')) {

      let zoomVal = 14.19;

      mapboxgl.accessToken = 'pk.eyJ1IjoibXljbGllbnRpc3JpY2giLCJhIjoiY2poaXZyNDhhMDI1MjNjcWtkNzJ0YnhjeSJ9.XFby3OF5X5CTTNAOJdSn7w';
      let map = new mapboxgl.Map({
        container: 'mapbox',
        style: 'mapbox://styles/myclientisrich/cl6xofnbt003e15qftanorqr7',
        center: [7.742914521916146, 48.584012085469155],
        zoom: zoomVal,
        pitch: 48.5,
        bearing: 342.4,
        interactive: true,
        passive: true
      });
      let locationPing1 = [];
      let location = [7.742914521916146, 48.584012085469155];
      locationPing1.push(location);
      locationPing1.forEach(function (location, index) {
        let el = document.createElement('div');
        el.classList.add('marker-ping');
        new mapboxgl.Marker(el)
          .setLngLat(location)
          .addTo(map);
      });
      map.addControl(new mapboxgl.NavigationControl());
      map.scrollZoom.disable();
    }
  }
}
export default Map;